export const IOS_APP_STORE_LINK = "https://apps.apple.com/us/app/prc-macro/id1509889470";

export const ANDROID_APP_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.shrill_recipe_34516&hl=en&gl=US";
